import { Fragment, useMemo } from "react";
import { useDataParams } from "../../../hooks/useData";
import { Form } from "react-bootstrap";

const selectStyle = { width: "366px" };
const emptyObj = {};

export default function UserTypesSelect(props) {
  const { value, handleChange, show, style = emptyObj, isInvalid } = props;
  const params = useDataParams();
  const types = useMemo(() => {
    if (params) {
      return Object.keys(params.content.types).map((value) => {
        return { value, label: params.content.types[value].name };
      });
    }

    return [];
  }, [params]);

  if (show === false) return null;

  return (
    <Fragment>
      <Form.Control
        as="select"
        onChange={(e) => handleChange(e.target.value)}
        value={value || ""}
        style={{ ...style, ...selectStyle }}
        placeholder="Select Catalog"
        isInvalid={isInvalid}
        className={props.className}
      >
        <option value="">Select Catalog...</option>
        {(types || []).map((type, i) => (
          <option key={`${type.value}-${i}`} value={type.value}>
            {type.label}
          </option>
        ))}
      </Form.Control>
    </Fragment>
  );
}
